import { Role } from "@/lib/types";
import { UpdateRoleMenus } from "./UpdateRoleMenus";
import { UpdateRoleMetaForm } from "./UpdateRoleMetaForm";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTranslation } from "react-i18next";

interface Props {
  role: Role;
}

export const UpdateRole: React.FC<Props> = ({ role }) => {
  const { t } = useTranslation();

  return (
    <Tabs defaultValue="detail">
      <TabsList>
        <TabsTrigger value="detail">{t("common.detail")}</TabsTrigger>
        <TabsTrigger value="menus">{t("common.menus")}</TabsTrigger>
      </TabsList>
      <TabsContent value="detail">
        <UpdateRoleMetaForm role={role} />
      </TabsContent>
      <TabsContent value="menus">
        <UpdateRoleMenus role={role} />
      </TabsContent>
    </Tabs>
  );
};
